import { Icon, IconProps } from '@chakra-ui/react';

export function CheckIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.32923 13.2288L3.85423 9.75378L2.6709 10.9288L7.32923 15.5871L17.3292 5.58711L16.1542 4.41211L7.32923 13.2288Z" />
    </Icon>
  );
}
